import _ from 'lodash';
import { getMaxZIndex, getMinZIndex } from 'crazyEditor/core/elements/utils/elementFilterUtils';
import { getViewState } from '../helpers/elementViewHelpers';
import * as elementActionTypes from '../actions/elementPropsActions';
import update from 'react-addons-update';

export default function reducer(state = {}, action = {}) {
  let element;
  let elementId;
  let viewState;
  let elementsToUpdate = {};
  let elementLayout;
  let oldZIndex;
  let newZIndex;
  let elementToReplace;
  let stateUpdate;

  switch (action.type) {
    case elementActionTypes.SEND_TO_FRONT:
      viewState = getViewState(action.viewMode, state);
      elementId = action.ids[0];

      return update(state, {
        [viewState]: {
          elements: {
            [elementId]: {
              compProps: {
                zIndex: {
                  $set: getMaxZIndex(state[viewState].elements) + 1
                }
              }
            }
          }
        }
      });
    case elementActionTypes.SEND_TO_BACK:
      viewState = getViewState(action.viewMode, state);
      elementId = action.ids[0];

      stateUpdate = {
        [viewState]: {
          elements: {
            [elementId]: {
              compProps: {
                zIndex: {
                  $set: Math.max(0, getMinZIndex(state[viewState].elements) - 1)
                }
              }
            }
          }
        }
      };
      _.forEach(state[viewState].elements, (element, id) => {
        if (id === elementId) {
          return;
        }
        stateUpdate[viewState].elements[id] = {
          compProps: {
            zIndex: {
              $set: element.compProps.zIndex + 1,
            }
          }
        };
      });
      return update(state, stateUpdate);
    case elementActionTypes.SEND_FORWARD:
      viewState = getViewState(action.viewMode, state);
      elementId = action.ids[0];
      element = state[viewState].elements[elementId];
      oldZIndex = element.compProps.zIndex;
      newZIndex = oldZIndex + 1;
      elementToReplace = _.find(state[viewState].elements, otherElement => {
        return otherElement.compProps.zIndex === newZIndex;
      });

      stateUpdate = {
        [viewState]: {
          elements: {
            [elementId]: {
              compProps: {
                zIndex: {
                  $set: newZIndex
                }
              }
            }
          }
        }
      };
      if (elementToReplace) {
        stateUpdate[viewState].elements[elementToReplace.id] = {
          compProps: {
            zIndex: {
              $set: oldZIndex
            }
          }
        };
      }
      return update(state, stateUpdate);
    case elementActionTypes.SEND_BACKWARD:
      if (oldZIndex <= 1) {
        return state;
      }
      viewState = getViewState(action.viewMode, state);
      elementId = action.ids[0];
      element = state[viewState].elements[elementId];
      oldZIndex = element.compProps.zIndex;
      newZIndex = oldZIndex - 1;
      elementToReplace = _.find(state[viewState].elements, otherElement => {
        return otherElement.compProps.zIndex === newZIndex;
      });

      stateUpdate = {
        [viewState]: {
          elements: {
            [elementId]: {
              compProps: {
                zIndex: {
                  $set: newZIndex
                }
              }
            }
          }
        }
      };
      if (elementToReplace) {
        stateUpdate[viewState].elements[elementToReplace.id] = {
          compProps: {
            zIndex: {
              $set: oldZIndex
            }
          }
        };
      }
      return update(state, stateUpdate);
    case elementActionTypes.LOCK_ASPECT_RATIO:
      viewState = getViewState(action.viewMode, state);
      elementId = action.ids[0];
      element = state[viewState].elements[elementId];
      elementLayout = element.layout;

      return update(state, {
        [viewState]: {
          elements: {
            [elementId]: {
              layout: {
                aspectRatio: {
                  $set: elementLayout.width / elementLayout.height
                }
              }
            }
          }
        }
      });
    case elementActionTypes.UNLOCK_ASPECT_RATIO:
      viewState = getViewState(action.viewMode, state);
      elementId = action.ids[0];

      return update(state, {
        [viewState]: {
          elements: {
            [elementId]: {
              layout: {
                aspectRatio: {
                  $set: null
                }
              }
            }
          }
        }
      });
    case elementActionTypes.LOCK_ELEMENT:
      viewState = getViewState(action.viewMode, state);
      elementsToUpdate = {};
      _.forEach(action.ids, (id) => {
        elementId = id;
        elementsToUpdate[elementId] = {
          locked: {
            $set: true
          }
        };
      });
      if (!_.isEmpty(elementsToUpdate)) {
        return update(state, {
          [viewState]: {
            elements: elementsToUpdate
          }
        });
      }
      return state;
    case elementActionTypes.UNLOCK_ELEMENT:
      viewState = getViewState(action.viewMode, state);
      elementsToUpdate = {};
      _.forEach(action.ids, (id) => {
        elementId = id;
        elementsToUpdate[elementId] = {
          locked: {
            $set: false
          }
        };
      });
      if (!_.isEmpty(elementsToUpdate)) {
        return update(state, {
          [viewState]: {
            elements: elementsToUpdate
          }
        });
      }
      return state;
    default:
      return state;
  }
}
